import axiosInstance from "../../../myAxiosInstance";
const baseApiUrl = process.env.REACT_APP_HOST + process.env.REACT_APP_BASE_API_URL;

async function getPsActivityData(data) {
    try {
        const result = await axiosInstance.get(`${baseApiUrl}admin/jobs/ps-activity/dashboard`, { params: data });
        return result;
    } catch (err) {
        console.error('error in getting PsActivityData ', err);
    }
};

export const psProductivityDashboardServices = {
    getPsActivityData
}